<ng-container *ngIf="!countryfilter">
<div class="countryList-Container">
    <div class="country-Filter">

        <ul>
            <h3>Select Country</h3>

            <li *ngFor="let country of countryList">
                <div *ngIf="country" (click)="selectCountry(country)">
                    <img *ngIf="country['countryName']" [src]="getCountryFlag(country['countryName']| uppercase)" />
                    <span *ngIf="country['countryName']">{{country['countryName']}}</span>
                    <!-- <img src="assets/img/rightArrow.svg" class="arrow"> -->
                    <mat-select *ngIf="country['countryName']">
                        <mat-option *ngFor="let code of getBusinessNameListForCountry(country['countryName'])" [value]="code" (click)="selectBusiness(code)">
                          {{code}}
                        </mat-option>
                        <button mat-stroked-button *ngIf="country" (click)="skipBusinessOption()">Skip</button>
                      </mat-select>
                </div>
            </li>
        </ul>
    </div>
</div>
</ng-container>
<ng-container *ngIf="countryfilter">
    <app-header></app-header>
    <app-menu></app-menu>
    <router-outlet></router-outlet>
</ng-container>